import { Link } from 'react-router-dom';

/**
 * The primary action, reachable from every page in one tap.
 *
 * **Words rather than a camera glyph.** The icon assumed a camera means
 * "upload yours" — but on a page full of other people's photographs it reads
 * just as easily as "take a picture" or "open the gallery", and a guest who is
 * unsure does not tap a button to find out. There is no second affordance to
 * explain it either: the whole control is one 62px circle in a corner.
 *
 * It costs the perfect circle, which is why it is now a pill. That is the right
 * trade for the one control the site most needs a guest to press.
 */
export default function CameraFab() {
  return (
    <Link className="fab" to="/upload" data-tour="add-photo">
      Add Photo
    </Link>
  );
}
